import React from 'react';

import Framework from "@beardeddevops/react.framework";
import {Collections, Objects} from "components";

import {Button} from "reactstrap";
import UserRoles from "constants/UserRoles";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";

const breadcrumbsStatic = [{
	name: 'Projects',
	url: '/projects',
	icon: 'users',
}];

const all_roles = [10, 15, 20, 21, 25, 26, 30];

class Projects extends Framework.Components.View {

	constructor(props) {
		super(props, UserRoles[props.roles[0]]);
		this.state.tab = UserRoles[props.roles[0]];
	}

	componentDidMount() {
		this.setState({static_roles: this.props.roles[0] === 10 ? all_roles : this.props.roles.filter((role) => role === 90 || all_roles.includes(role)).sort((a, b) => a - b)})
	}

	refreshPage = () => {
		this.setState({
			key: Math.random(),
			refresh: !this.state.refresh
		});
	};

	render() {
		let {history} = this.props;
		let {static_roles} = this.state;
		if (!static_roles) {
			return null;
		}

		return (
			<div className="container-fluid">

				<Framework.Components.PageBar breadcrumbs={breadcrumbsStatic} history={history}>
					{static_roles.some(role => [UserRoles.Admin, UserRoles.Executive].includes(role)) && <Button data-cy="add-customer" onClick={this.toggle('modalTaskAddBulk')} size={"sm"} color="primary">
						Bulk Add
					</Button>}
					{static_roles.some(role => [UserRoles.Admin, UserRoles.Executive, UserRoles.Projects].includes(role)) && <Button data-cy="add-customer" onClick={this.toggle('modalTaskAdd')} size={"sm"} color="primary">
						<i className="fa fa-users"/>&nbsp;&nbsp;Add Action Item
					</Button>}

					<Button onClick={async () => {
						await this.refreshPage();
					}} size={"sm"} color="primary">
						<i className="fa fa-users"/>&nbsp;&nbsp;Refresh Data
					</Button>
				</Framework.Components.PageBar>

				<Framework.Elements.UniversalModal
					regions={this.props.regions}
					name={"Bulk Add - New Action Item"}
					object={Objects.BulkAddTask}
					toggle={this.state.modalTaskAddBulk}
					reportClose={this.reportClose('modalTaskAddBulk')}
					afterSave={async () =>	this.refreshPage()}
					hideGoTo={true}
					objectProps={{task_role: UserRoles[this.state.tab]}}
				/>
				<Framework.Elements.UniversalModal
					regions={this.props.regions}
					name={`New Action Item For ${this.state.tab} Group`}
					object={Objects.ManagerTask}
					toggle={this.state.modalTaskAdd}
					reportClose={this.reportClose('modalTaskAdd')}
					afterSave={() => this.refreshPage()}
					hideGoTo={true}
					objectProps={{task_role: UserRoles[this.state.tab]}}
				/>

				<Tabs value={this.state.tab} onChange={this.handleTabChange} component={'div'}>
					{static_roles.map((role) => role !== 90 && <Tab key={Math.random()} label={UserRoles[role]} value={UserRoles[role].replace(' ', '')}/>)}
				</Tabs>


				<Collections.Projects
					key={this.state.key}
					history={history}
					reloadShell={this.props.reloadShell}
					reloadPage={this.refreshPage}
					reloadSelf={this.state.refresh}
					regions={this.props.regions}
					filter={UserRoles[this.state.tab]}
					allowDone={static_roles.some(role => [UserRoles.Admin, UserRoles.Executive, UserRoles.Projects].includes(role))}
					handleTabChange={this.handleTabChange}
					user={this.props.rootState.user}
				/>

			</div>
		);
	}
}

export default Framework.Components.withRootState(Projects);

